import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";
import { BooleanFilter as BooleanFilterType, Column } from "./types";

type Props = {
  column: Column;
};

export const BooleanFilter = ({ column }: Props) => {
  const filter = column.filter as BooleanFilterType;
  const { setFilter, strings } = useContext(ColumnOptionsContext);

  const options: IChoiceGroupOption[] = [
    { key: "true", text: strings.booleanFilterTrueLabel },
    { key: "false", text: strings.booleanFilterFalseLabel },
  ];

  const selectedKey =
    filter.value === true
      ? "true"
      : filter.value === false
      ? "false"
      : undefined;

  return (
    <ChoiceGroup
      selectedKey={selectedKey}
      options={options}
      onChange={(_, option) => {
        if (!option) return;
        const value =
          option.key === "true" ? true : option.key === "false" ? false : null;
        setFilter(column.key, { ...filter, value });
      }}
    />
  );
};
